<ng-container *ngIf="!isLoadingView; else tplNoData">
  <ng-container *ngIf="canDisplayGrille(); else tplNoRepas">

    <div id="accordion">
      <dx-accordion
        *ngIf="isPrestationFirst()"
        [dataSource]="prestations"
        [collapsible]="true"
        [multiple]="true"
        [animationDuration]="300"
        [selectedItems]="prestations"
      >
        <div *dxTemplate="let item of 'title'">
          <h6>{{ item.prestation.libelle }} > {{item.prestation.libelle}}</h6>
        </div>
        <div class="overflow-auto" *dxTemplate="let item of 'item'">
          <yo-prestations-repas [prestation]="item.prestation" [cols]="cols" [repas]="item.repas" [datesFacturation]="datesFacturation" [selectedCell]="selectedCell"
                                [datesDetailsFromMenu]="datesDetailsFromMenu" [typeEffectif]="typeEffectif"></yo-prestations-repas>
        </div>
      </dx-accordion>

      <dx-accordion
        *ngIf="!isPrestationFirst()"
        [dataSource]="repas"
        [collapsible]="true"
        [multiple]="true"
        [animationDuration]="300"
        [selectedItems]="repas"
      >
        <div *dxTemplate="let item of 'title'">
          <h6>{{ item.repas.libelle }}</h6>
        </div>
        <div class="overflow-auto" *dxTemplate="let item of 'item'">
          <yo-repas-prestations [prestations]="item.prestations" [cols]="cols" [repas]="item.repas" [datesFacturation]="datesFacturation" [selectedCell]="selectedCell"
                                [datesDetailsFromMenu]="datesDetailsFromMenu" [typeEffectif]="typeEffectif"></yo-repas-prestations>
        </div>
      </dx-accordion>
    </div>

  </ng-container>
</ng-container>

<ng-template #tplNoRepas>
  <div class="mt-4 mb-4">
    <i class="mg-r-5 fas fa-exclamation-triangle danger-color"></i>Aucun menu existant pour cette période.
  </div>
</ng-template>

<ng-template #tplNoData>
  <div class="indicators">
    <dx-load-indicator
      id="large-indicator"
      height="60"
      width="60"
    ></dx-load-indicator>
  </div>
</ng-template>
